import React, { useState } from "react";
import login_bg from "../../Asset/login/login_bg.jpg";
import { RiCloseCircleFill } from "react-icons/ri";
import { FaMobileAlt } from "react-icons/fa";
import authModel from "../../model/auth.model";
import { toast } from "../../lib/helper";
import { useContact } from "../../useContext/ContactContext";
import { useNavigate } from "react-router-dom";
import logo from "../../Asset/ordercard/logo.png";
import wrong from "../../Asset/toast/wrong.png"

const Login = ({ setShowLoginPopup, setIsLoggedIn, setSignup }) => {
  const [isNewUser, setIsNewUser] = useState(true);
  const { contact, setContact, GetUser } = useContact();
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const Navigate = useNavigate();

  const Login = async (e) => {
    setLoading(true);
    e.preventDefault();
    const form = new FormData(e.target);

    if (isNewUser) {
      const contactNumber = form.get("contact_no");
      if (!contactNumber) {
        toast("Please enter your contact number", "warning");
        return;
      }

      setContact(contactNumber);

      authModel
        .login(form)
        .then((response) => {
          setLoading(false);
          
          if (response?.data?.isNewUser === true) {
            setSignup(true);
            setShowLoginPopup(false);
            toast(
              `${response?.data?.message} to mobile, and welcome to signup Screen `,
              "success"
            );
          }
          if (response?.data?.isNewUser === false) {
            setIsNewUser(false);
            toast(response?.data?.message, logo);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error:", error);
          toast(error?.response?.data?.message, wrong);
        });
    } else {
      if (!otp) {
        toast("Please enter the OTP", "warning");
        return;
      }

      const otpForm = new FormData();
      otpForm.append("contact_no", contact);
      otpForm.append("otp", otp);

      authModel
        .VerifyOtp(otpForm)
        .then((response) => {
          setLoading(false);
          toast(response?.data?.message, logo);

          sessionStorage.setItem("token", response?.data?.access_token);

          sessionStorage.setItem(
            "user",
            JSON.stringify(response?.data?.userData)
          );
          GetUser();
          setIsLoggedIn(true);
          setShowLoginPopup(false);
          console.log("OTP Verified:", response);
        })
        .catch((error) => {
          setLoading(false);
          toast(error?.response?.data?.message, wrong);
          console.log("Error:", error);
        });
    }
  };

  return (
    <div className="w-full fixed inset-0 bg-black/50 flex justify-center items-center overflow-y-auto">
      <div
        className="h-[500px] w-11/12 sm:h-[565px] md:h-[450px] lg:h-[470px] xl:h-[600px] 2xl:h-[600px]  sm:w-2/3 md:w-2/5 lg:w-1/3 xl:w-1/3 2xl:w-1/4 relative rounded-3xl bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${login_bg})` }}
      >
        <div className="p-6 absolute top-0 w-full">
          <div className="flex justify-end">
            <RiCloseCircleFill
              className="text-white text-4xl cursor-pointer hover:text-red-500"
              onClick={() => {
                setShowLoginPopup(false);
              }}
            />
          </div>
        </div>
        <div className="w-full flex flex-col text-4xl  sm:text-4xl md:text-2xl xl:text-4xl lg:text-3xl  py-24 md:py-16 lg:py-20 xl:py-24 px-8">
          <span
            className="text-gray-800"
            style={{ fontFamily: "Salsa, sans-serif" }}
          >
            Welcome
          </span>
          <span
            className="text-textColor text-3xl sm:text-4xl md:text-2xl lg:text-3xl xl:text-4xl"
            style={{ fontFamily: "Salsa, sans-serif" }}
          >
            Sehatful
          </span>
        </div>
        <div className="absolute bottom-10 md:bottom-8 sm:bottom-10 lg:bottom-8 xl:bottom-14 px-2 sm:px-8 md:px-6 lg:px-8 w-full flex flex-col justify-center">
          <span className="font-semibold w-full flex justify-center text-xl">
            {isNewUser ? "Continue Login" : "Verify OTP to Login"}

          </span>

          <form onSubmit={Login}>
            {/* Contact Input (Hidden if isNewUser is false) */}
            {isNewUser ? (
              <div className="flex gap-2 w-full bg-white items-center py-2.5 px-2  mt-6 md:mt-3 lg:mt-4 xl:mt-6 rounded-md">
                <FaMobileAlt />
                <input
                  type="tel"
                  name="contact_no"
                  placeholder="Enter Your Number"
                  maxLength={10}
                  pattern="\d{10}"
                  className="w-full border-none focus:outline-none focus:ring-0"
                  onInput={(e) => {
                    setContact(e.target.value.replace(/\D/, "").slice(0, 10));
                  }}
                  value={contact}
                  required
                />
              </div>
            ) : (
              // OTP Input (Shown when isNewUser is false)
              <div className="flex gap-2 w-full bg-white items-center py-1.5 px-2 mt-6 md:mt-3 xl:mt-6 rounded-md">
                <input
                  type="text"
                  name="otp"
                  placeholder="Enter OTP"
                  maxLength={4}
                  className="w-full border-none focus:outline-none focus:ring-0 text-center text-xl"
                  onInput={(e) => {
                    setOtp(e.target.value.replace(/\D/, "").slice(0, 4));
                  }}
                  value={otp}
                  required
                />
              </div>
            )}

            <button
              className="bg-textColor text-white mt-6 md:mt-3 xl:mt-6 px-2 py-2.5 rounded-3xl w-full "
              type="submit"
            >
              {loading ? (
                <span className="loading loading-bars loading-xs"></span>
              ) : (
                <> {isNewUser ? "Continue" : "Verify OTP"} </>
              )}
            </button>
          </form>

          <div className="flex flex-col justify-center items-center mt-6 md:mt-3 lg:mt-4 xl:mt-6 text-sm">
            <span className="flex text-xs ">
              By tapping on {isNewUser ? "“Continue”" : "“Verify OTP”"} button, you agreed to our
            </span>
            <span className="flex gap-2 text-xs font-semibold text-textColor">
              <span
                className="cursor-pointer underline"
                onClick={() => {
                  Navigate("/termandcondion");
                  setShowLoginPopup(false);
                }}
              >
                Terms & Conditions
              </span>{" "}
              &{" "}
              <span
                className="cursor-pointer underline"
                onClick={() => {
                  Navigate("/privacy");
                  setShowLoginPopup(false);
                }}
              >
                Privacy Policy
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
